import { useState } from "react"
import type { PropsWithChildren } from "react"
import { EditStageContext } from "./EditStageContext"

export const EditStageContextProvider = ({ children }: PropsWithChildren) => {
	const [editStage, setEditStage] = useState<string>()

	return (
		<EditStageContext.Provider
			value={{
				editStage,
				setEditStage,
			}}
		>
			{children}
		</EditStageContext.Provider>
	)
}
